<div class="full-height layout-column">

  <!--Table Skeleton, shown only until the accounts have loaded for the first time-->
  <div *ngIf="!isInitialized" class="flex layout-column bringoz-table bringoz-table-skeleton visit-plan-accounts-table-skeleton fade-element-in-only">

    <div class="tr-header layout-row layout-align-start-center">
      <div class="th skeleton-total-col layout-align-center-center">
        <div class="bringoz-skeleton" style="width: 90px; height: 10px;"></div>
      </div>
      <div class="th skeleton-day-col layout-align-center-center" *ngFor="let col of skeletonDayColumns">
        <div class="bringoz-skeleton" style="width: 90px; height: 10px;"></div>
      </div>
    </div>

    <div class="rows-container full-height layout-column">
      <div class="tr layout-row layout-align-start-center" *ngFor="let row of skeletonRows">

        <div class="td skeleton-total-col layout-align-start-center">
          <div class="bringoz-skeleton skeleton-checkbox"></div>
          <div class="bringoz-skeleton skeleton-icon"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 90px;"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 30px;"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 30px;"></div>
        </div>

        <div class="td skeleton-day-col layout-align-start-center" *ngFor="let col of skeletonDayColumns">
          <div class="bringoz-skeleton skeleton-icon"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 40px;"></div>
          <div class="bringoz-skeleton skeleton-icon"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 55px;"></div>
        </div>

      </div>
    </div>

  </div>

  <!--Table-->
  <div *ngIf="isInitialized" class="flex layout-column bringoz-table bringoz-table-sticky scrollable">

    <!--Table Headers-->
    <div id="header-one" class="tr layout-row layout-align-start-center">

      <div class="layout-row layout-align-center-center th sticky resizer">
        <div class="resize-handle"></div>
        <span class="br-body-1 font-weight-600 gray-100" translate>Total</span>
      </div>

      <div *ngFor="let visitScheduleDay of visitScheduleDays"
           class="th flex layout-row layout-align-center-center text-ellipsis"
           [style.width.px]="dayColWidth"
           (mouseenter)="hoveredDayId = visitScheduleDay.id"
           (mouseleave)="hoveredDayId = null">
        <span
          class="br-body-1 font-weight-600 gray-100">{{ visitScheduleDay | bringozDay: 'date': 'long' }} {{ visitScheduleDay | bringozDate: 'date' }}</span>
        <bringoz-button *ngIf="visitScheduleDays.length > 1" type="tertiary"
                        size="fit"
                        (onClick)="onFilterViewByVisitScheduleDay.emit(visitScheduleDay)">

          <bringoz-icon iconName="calendar-outline" class="gray-100 margin-left-5" classSize="md"></bringoz-icon>

        </bringoz-button>

        <div ngbDropdown container="body" class="action-menu-container">
          <button class="action-menu"
                  (click)="$event.stopPropagation();"
                  ngbDropdownToggle>
            <bringoz-icon iconName="menu"></bringoz-icon>
          </button>
          <div ngbDropdownMenu aria-labelledby="action-menu">

            <div class="day-menu-item"
                 [ngbTooltip]="getBlockedDayTooltipKey(visitScheduleDay.id) | translate"
                 container="body"
                 openDelay="300">
              <button
                ngbDropdownItem
                [disabled]="dispatchedDayMap[visitScheduleDay.id]"
                (click)="onRemoveDeliveriesByDay(visitScheduleDay.date)">
                <div class="layout-row layout-align-start-center">
                  <span class="br-body-2 primary-100" translate>Remove all deliveries for this day</span>
                </div>
              </button>
            </div>

            <div class="day-menu-item"
                 [ngbTooltip]="getBlockedDayTooltipKey(visitScheduleDay.id) | translate"
                 container="body"
                 openDelay="300">
              <button
                ngbDropdownItem
                [disabled]="dispatchedDayMap[visitScheduleDay.id]"
                (click)="onRemoveCallsByDay(visitScheduleDay.date)">
                <div class="layout-row layout-align-start-center">
                  <span class="br-body-2 primary-100" translate>Remove all Calls</span>
                </div>
              </button>
            </div>

          </div>
        </div>
      </div>


    </div>

    <div id="header-two" class="tr layout-row layout-align-start-center">

      <div class="layout-row layout-align-start-center th sticky">
        <!--        <span class="br-body-1 font-weight-600 gray-100 flex-5">-->
        <!--          #-->
        <!--        </span>-->
        <span class="br-body-1 font-weight-600 gray-100 flex" translate>
          Store
        </span>
        <!--        <span class="br-body-1 font-weight-600 gray-100 flex-10" translate>-->
        <!--          Note-->
        <!--        </span>-->
        <span *ngIf="tableFilterColumns.isDisplayCallTypes"
              class="br-body-1 font-weight-600 gray-100 total-header"
              [ngbTooltip]="'Merchandise' | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'SCHEDULING_PROJECT_SHORTCUTS.' + 'M' | translate }}
        </span>
        <span *ngIf="tableFilterColumns.isDisplayCallTypes"
              class="br-body-1 font-weight-600 gray-100 total-header"
              [ngbTooltip]="'Orders' | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'SCHEDULING_PROJECT_SHORTCUTS.' + 'O' | translate }}
        </span>
        <span *ngIf="tableFilterColumns.isDisplayCallTypes"
              class="br-body-1 font-weight-600 gray-100 total-header"
              [ngbTooltip]="'Sales' | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'SCHEDULING_PROJECT_SHORTCUTS.' + 'S' | translate }}
        </span>
        <span *ngIf="tableFilterColumns.isDisplayDeliveryUnits"
              class="br-body-1 font-weight-600 gray-100 total-header du"
              [ngbTooltip]="'Delivery Units' | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'SCHEDULING_PROJECT_SHORTCUTS.' + 'D.U' | translate }}
        </span>
        <span *ngIf="tableFilterColumns.isDisplayDeliveryDays"
              class="br-body-1 font-weight-600 gray-100 total-header du"
              [ngbTooltip]="'Deliveries' | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'SCHEDULING_PROJECT_SHORTCUTS.' + 'D' | translate }}
        </span>
        <span *ngIf="tableFilterColumns.isDisplayServiceTime"
              class="br-body-1 font-weight-600 gray-100 total-header large"
              [ngbTooltip]="'In-Store Time' | translate"
              openDelay="300"
              triggers="hover"
              container="body"
              translate>
          In-store T.
        </span>
        <!--        <span class="br-body-1 font-weight-600 gray-100 flex-10"-->
        <!--              [ngbTooltip]="'Merchandise Units' | translate"-->
        <!--              openDelay="300"-->
        <!--              triggers="hover"-->
        <!--              container="body">-->
        <!--          {{ 'SCHEDULING_PROJECT_SHORTCUTS.' + 'M.U' | translate }}-->
        <!--        </span>-->
      </div>

      <!--Day details-->
      <div *ngFor="let visitScheduleDay of visitScheduleDays"
           class="th flex layout-row layout-align-start-center text-ellipsis"
           [style.width.px]="dayColWidth">
          <span
            *ngIf="tableFilterColumns.isDisplayDeliveryEtd"
            class="br-body-1 font-weight-600 gray-100 flex-15 text-ellipsis"
                [ngbTooltip]="'Delivery' | translate"
                openDelay="300"
                triggers="hover"
                container="body"
                translate>
            Del
          </span>
        <span *ngIf="tableFilterColumns.isDisplayDeliveryUnits"
              class="br-body-1 font-weight-600 gray-100 flex-10 text-ellipsis"
              [ngbTooltip]="'Units' | translate"
              openDelay="300"
              triggers="hover"
              container="body">
            {{ 'SCHEDULING_PROJECT_SHORTCUTS.' + 'D.U' | translate }}
          </span>
        <span *ngIf="tableFilterColumns.isDisplayCallTypes"
              style="height: 13px !important;"
              class="br-body-1 font-weight-600 gray-100 flex text-ellipsis"
              [ngbTooltip]="'Call type' | translate"
              openDelay="300"
              triggers="hover"
              container="body" translate>
            Call type
          </span>
        <span *ngIf="tableFilterColumns.isDisplayServiceTime"
              class="br-body-1 font-weight-600 gray-100 flex-25 margin-left-10 text-ellipsis"
              [ngbTooltip]="'In-Store Time' | translate"
              openDelay="300"
              triggers="hover"
              container="body"
              translate>
               In-store T.
          </span>
      </div>


    </div>

    <!--Table Body-->
    <div *ngIf="accounts?.length" class="flex layout-column rows-container full-height">

      <!--Repeater-->
      <div class="full-height flex layout-column">
        <cdk-virtual-scroll-viewport [itemSize]="50" class="flex layout-column viewport"
                                     (scroll)="getNextBatch()">

          <app-visit-plan-accounts-table-row *cdkVirtualFor="let account of accounts; let index = index; let odd = odd"
                                             class="item flex layout-column"
                                             [ngClass]="{'odd': odd}"
                                             [programTypeAliasMap]="programTypeAliasMap"
                                             [account]="account"
                                             [from]="from"
                                             [to]="to"
                                             [index]="index + 1"
                                             [visitPlan]="visitPlan"
                                             [totalsColSize]="totalsColumnWidth"
                                             [visitScheduleDays]="visitScheduleDays"
                                             [dayColWidth]="dayColWidth"
                                             [visitPlanAccountAnalysis]="visitPlanAccountsAnalysisMap[account.accountId]"
                                             [tableFilterColumns]="tableFilterColumns"
                                             (onDeleteCalls)="onDeleteCalls.emit({deletedCallIds: $event.deletedCallIds, cellId: $event.cellId})"
                                             (onUpdateVisitCellTracker)="onUpdateVisitCellTracker.emit($event)"
                                             (onAddCall)="onAddCall.emit({cellId: $event.cellId, date:$event.date, account: account.accountReference})"
                                             (onAdvanceEditCall)="onAdvanceEditCall.emit({cellId: $event.cellId, call: $event.call, visitPlanCell: $event.visitPlanCell, account: account.accountReference})"
                                             (onUpdateCallsTimeWindow)="onUpdateCallsTimeWindow.emit({list: $event.list, cellId: $event.cellId})"
                                             (onAssignCallsToResource)="onAssignCallsToResource.emit($event)"
                                             (onUnAssignCalls)="onUnAssignCalls.emit($event)"
                                             (onLockAccountChange)="onLockAccountChange.emit($event)"
                                             (onLockCallChange)="onLockCallChange.emit($event)"
                                             (onRemoveDeliveries)="onRemoveDeliveries.emit($event)"
                                             (onOpenAccountInfo)="onOpenAccountInfo.emit($event)">

          </app-visit-plan-accounts-table-row>

        </cdk-virtual-scroll-viewport>
      </div>
    </div>

    <div *ngIf="!!visitPlanDayTotals && accounts?.length" id="footer"
         class="tr layout-row layout-align-start-center footer-row">
      <div class="layout-row layout-align-start-center th sticky">
        <!--        <span class="br-body-1 font-weight-600 gray-100 flex-5">#</span>-->
        <div class="br-body-1 font-weight-600 gray-100 flex layout-column">
          <span>{{ totalsData.totalAccounts }}</span>
          <span *ngIf="totalsData.totalAccounts !== totalsInitialData.totalAccounts" style="text-decoration: line-through;">{{totalsInitialData.totalAccounts}}</span>
        </div>
<!--        <span class="br-body-1 font-weight-600 gray-100 total-header"></span>-->
        <!--        <span class="br-body-1 font-weight-600 gray-100 flex-10"></span>-->
        <div *ngIf="tableFilterColumns.isDisplayCallTypes"
              class="br-body-1 font-weight-600 gray-100 total-header text-ellipsis layout-column">
          <span [appBringozTooltip]="totalsData.merchandise | number" [tooltipPlacement]="'top'" ngbTooltip>{{ totalsData.merchandise | number }}</span>
          <span *ngIf="totalsData.merchandise !== totalsInitialData.merchandise" style="text-decoration: line-through;">{{totalsInitialData.merchandise | number}}</span>
        </div>
        <div *ngIf="tableFilterColumns.isDisplayCallTypes"
              class="br-body-1 font-weight-600 gray-100 total-header text-ellipsis layout-column">
          <span [appBringozTooltip]="totalsData.orders | number" [tooltipPlacement]="'top'" ngbTooltip>{{ totalsData.orders | number }}</span>
          <span *ngIf="totalsData.orders !== totalsInitialData.orders" style="text-decoration: line-through;">{{totalsInitialData.orders | number}}</span>
        </div>
        <div *ngIf="tableFilterColumns.isDisplayCallTypes"
              class="br-body-1 font-weight-600 gray-100 total-header text-ellipsis layout-column">
          <span [appBringozTooltip]="totalsData.sells | number" [tooltipPlacement]="'top'" ngbTooltip>{{ totalsData.sells | number }}</span>
          <span *ngIf="totalsData.sells !== totalsInitialData.sells" style="text-decoration: line-through;">{{totalsInitialData.sells | number}}</span>
        </div>
        <div *ngIf="tableFilterColumns.isDisplayDeliveryUnits"
              class="br-body-1 font-weight-600 gray-100 total-header du text-ellipsis layout-column">
          <span [appBringozTooltip]="totalsData.totalDeliveryUnits | number" [tooltipPlacement]="'top'" ngbTooltip>{{ totalsData.totalDeliveryUnits | number }}</span>
          <span *ngIf="totalsData.totalDeliveryUnits !== totalsInitialData.totalDeliveryUnits" style="text-decoration: line-through;">{{totalsInitialData.totalDeliveryUnits | number}}</span>
        </div>
        <div *ngIf="tableFilterColumns.isDisplayDeliveryDays"
              class="br-body-1 font-weight-600 gray-100 total-header du text-ellipsis layout-column">
          <span [appBringozTooltip]="totalsData.totalDeliveryDays | number" [tooltipPlacement]="'top'" ngbTooltip>{{ totalsData.totalDeliveryDays | number }}</span>
          <span *ngIf="totalsData.totalDeliveryDays !== totalsInitialData.totalDeliveryDays" style="text-decoration: line-through;">{{totalsInitialData.totalDeliveryDays | number}}</span>
        </div>
        <div *ngIf="tableFilterColumns.isDisplayServiceTime"
          class="br-body-1 font-weight-600 gray-100 total-header large text-ellipsis layout-column">
          <span  [appBringozTooltip]="totalsData.totalServiceTime | bringozTimeHHMM" [tooltipPlacement]="'top'" ngbTooltip>{{ totalsData.totalServiceTime | bringozTimeHHMM }}</span>
          <span *ngIf="totalsData.totalServiceTime !== totalsInitialData.totalServiceTime" style="text-decoration: line-through;">{{totalsInitialData.totalServiceTime | bringozTimeHHMM}}</span>
        </div>
      </div>

      <div *ngFor="let day of visitPlanDayTotals; let index = index"
           class="th flex layout-row layout-align-start-center text-ellipsis"
           [style.width.px]="dayColWidth">
        <span *ngIf="tableFilterColumns.isDisplayDeliveryEtd" class="br-body-1 font-weight-600 gray-100 flex-15">{{ day.deliveryDays | number }}</span>
        <span *ngIf="tableFilterColumns.isDisplayDeliveryDays" class="br-body-1 font-weight-600 gray-100 flex-20"
              translate>{{ day.deliveryUnits | number }}
        </span>
        <span *ngIf="tableFilterColumns.isDisplayCallTypes" class="br-body-1 font-weight-600 gray-100 flex-45"
              translate>{{ day.operationalCalls | number }}</span>
        <span *ngIf="tableFilterColumns.isDisplayServiceTime" class="br-body-1 font-weight-600 gray-100 flex-25 margin-left-10"
              translate>{{ day.destinationServiceTime | bringozTimeHHMM }}</span>
      </div>
    </div>

    <!--Empty State-->
    <div *ngIf="!accounts?.length"
         class="flex-100 full-height layout-row layout-align-center-center overflow-auto fade-element-in-only">
      <app-empty-state src="assets/images/empty_state/empty_state_accounts.png"
                       text="No Accounts Found">
      </app-empty-state>
    </div>

  </div>

</div>
